import styled from 'styled-components';
import { Card } from '$components/basic/Card';
import { vars, media } from '$util/theme';

export default styled(Card)`
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  border: none !important;

  ${media.down('sm')} {
    &:first-child {
      margin-top: 20px;
    }
  }

  ${media.up('md')} {
    margin-top: 20px;
    margin-bottom: 30px;
    height: auto;
    flex-direction: column;
    justify-content: center;
  }
  .lower-div {
    text-align: left;
    margin-left: 15px;
    ${media.up('md')} {
      text-align: center;
      margin-left: 0;
    }
    p {
      color: ${vars.quantumverse.reskinColors.neutral700};
    }
    .title {
      font-weight: ${vars.fontWeight.bold};
      margin-top: 8px;
      margin-bottom: 3px;
    }
    &.cheaper-tile {
      .title {
        font-weight: ${vars.fontWeight.regular};
      }
      .content > span {
        font-weight: ${vars.fontWeight.bold};
      }
    }

    .-nobold {
      font-weight: ${vars.fontWeight.regular};
    }
  }
`;
